import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../../services/api";
import "./notice.css";

export default function NoticeList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ── load ── */
  const loadNotices = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/notices/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setNotices(res.data.notices || []);
    } catch (err) { console.error(err); setNotices([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadNotices(); }, []);

  /* ── delete ── */
  const deleteNotice = async (id) => {
    if (!window.confirm("Delete this notice?")) return;
    try {
      await API.delete(`/school-admin/notices/delete/${id}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setNotices(n => n.filter(x => x.id !== id));
    } catch (err) { console.error(err); alert("Failed to delete notice"); }
  };

  return (
    <div className="nt-page">

      {/* ══ HERO ══ */}
      <div className="nt-hero">
        <div className="nt-hero-left">
          <div className="nt-hero-icon">📢</div>
          <div>
            <h2 className="nt-hero-title">Notices</h2>
            <p className="nt-hero-sub">School announcements and circulars — {notices.length} total</p>
          </div>
        </div>
        <div className="nt-hero-right">
          <Link to="/school-admin/notices/add" className="nt-btn-add">+ Add Notice</Link>
        </div>
      </div>

      {/* ══ TABLE ══ */}
      <div className="nt-card">
        {loading ? (
          <div className="nt-empty">
            <div className="nt-empty-icon">⏳</div>
            <strong>Loading notices…</strong>
          </div>
        ) : notices.length === 0 ? (
          <div className="nt-empty">
            <div className="nt-empty-icon">📭</div>
            <strong>No notices yet</strong>
            <p>Create your first school notice</p>
          </div>
        ) : (
          <table className="nt-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Message</th>
                <th>Attachment</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {notices.map(n => (
                <tr key={n.id}>
                  <td><span className="nt-title-cell">{n.title}</span></td>
                  <td><span className="nt-msg-preview">{n.message}</span></td>
                  <td>
                    {n.file
                      ? <a href={n.file} target="_blank" rel="noreferrer" className="nt-link">📎 View</a>
                      : <span className="nt-no-file">No file</span>
                    }
                  </td>
                  <td><span className="nt-date-badge">🗓 {n.created_at}</span></td>
                  <td>
                    <button className="nt-btn-del" onClick={() => deleteNotice(n.id)}>
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}
